import { transparentize } from 'polished'
import { Creatable } from 'react-select'
import styled from 'styled-components'

export const InputOptionsPopup = styled.div`
    z-index: 3;
    position: absolute;
    width: 100%;
    background: ${({ theme }) => theme['gray-0']};
    border: 1px solid ${({ theme }) => theme['blue-500']};
    border-top: none;
    border-radius: 0 0 2px 2px;
    bottom: 0;
    left: 0;
    transform: translateY(calc(100% - 1px));
    overflow: hidden;

    &:empty {
        display: none;
    }

    > div {
        padding: 10px;

        .selected,
        &:hover {
            cursor: pointer;
            background: ${({ theme }) => theme['blue-200']};
        }
    }
`

export const SelectCreatable = styled(Creatable)`
    #barrierEditor-barrierEditModal-field-responsible,
    #barrierEditor-barrierEditModal-field-manualInteraction-responsible {
        height: 34px;
        margin: 0px;
        padding: 0px;
    }
    .Select-arrow-zone {
        display: none !important;
    }
`

export const AbsoluteLoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    > div {
        position: fixed;
        z-index: 999999;
        bottom: 0;
        right: 10px;
        width: 385px;
        height: calc(100% - 71px - 40px - 65px);
        background: ${({ theme }) => transparentize(0.75, theme['gray-200'])};
        display: flex;
        justify-content: center;
        align-items: center;
    }
`

export const HR = styled.hr`
    border-color: #bac0cb;
`
export const RedInfo = styled.div`
    color: ${({ theme }) => theme['red-700']};
    font-weight: 600;
    font-size: 11px;
    line-height: 16px;

    padding-top: 0px;
`
